/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceMetadataUpdateRequest } from '../../models/device-metadata-update-request';

export interface UpdateDeviceMetadata$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: DeviceMetadataUpdateRequest
}

export function updateDeviceMetadata(http: HttpClient, rootUrl: string, params: UpdateDeviceMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<Device>> {
  const rb = new RequestBuilder(rootUrl, updateDeviceMetadata.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Device>;
    })
  );
}

updateDeviceMetadata.PATH = '/api/v1/devices/{id}/update_metadata';
